module.exports = __webpack_public_path__ + "static/media/admissions-infra-health-1.166d16db.jpg";